/** Shared disclaimer copy for notice + modal */

export const DISCLAIMER_SHORT =
  "General guidance only—not a substitute for expert TTA (training and technical assistance), professional consulting, or formal compliance assessments.";

export const DISCLAIMER_FULL_TEXT =
  "The Accessibility Assistant provides general informational guidance on digital accessibility topics and regulatory developments. It is not a substitute for expert-provided training and technical assistance (TTA), professional accessibility consulting, or formal compliance assessments. For comprehensive accessibility testing and certification, consider using Revelo's full testing platform at";

export const IACCESSIBLE_URL = "https://iaccessible.com/";
